import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../../../../../../core/layout-components/search';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerTaskLabel = styled.div`
  display: flex;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerAnswers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Answer = styled.div`
  display: flex;
  padding: 20px 0;
`;

export const Tester = styled.div`
  display: flex;
  width: 15%;
`;

export const WrittenResponse = styled.div`
  display: flex;
  flex: 1;
`;

export const Search = styled(SearchLayoutComponent).attrs({
  isWritten: true,
})``;

export const Title = styled(TextLayoutComponent.Bold)`
  && {
    margin-right: 15px;
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const NoResults = styled(TextLayoutComponent)`
  && {
    margin: 30px auto;
  }
`;
